// İçe Aktar — /clients/kpi/import (M16 T11, mockup 04-07). KpiScreen iskeleti (müşteri/set kapısı)
// içinde ImportWizard; sihirbaz aktifken ContextBar müşteri/set değişimi onay ister (kural 9).
import { useState } from "react";
import { ImportWizard } from "../../components/kpi/import/ImportWizard";
import { KpiScreen } from "../../components/kpi/KpiScreen";
import { KPI_IMPORT_COPY } from "../../lib/kpi-import-copy";
import { KPI_COPY } from "../../lib/kpi-ui";
import { useKpiStore } from "../../stores/kpi-store";
import { useCreateSetNav } from "./use-create-set-nav";

export function KpiImportPage(): JSX.Element {
  const createSet = useCreateSetNav();
  const clientId = useKpiStore((s) => s.clientId);
  const setId = useKpiStore((s) => s.setId);
  const clients = useKpiStore((s) => s.clients);
  const sets = useKpiStore((s) => s.sets);
  const [wizardActive, setWizardActive] = useState(false);

  const client = clients.find((c) => c.id === clientId);
  const set = sets.find((s) => s.id === setId);
  const subtitle =
    client && set
      ? `${client.name} · ${set.name} — ${KPI_IMPORT_COPY.subtitle}`
      : KPI_IMPORT_COPY.subtitle;

  return (
    <KpiScreen
      title={KPI_COPY.titles.import}
      subtitle={subtitle}
      lock={wizardActive}
      lockTitle={KPI_IMPORT_COPY.lockTitle}
      lockBody={KPI_IMPORT_COPY.lockBody}
      onCreateSet={() => createSet()}
      onCreateSetForClient={(id) => createSet(id)}
    >
      {clientId && setId ? (
        <ImportWizard
          key={`${clientId}:${setId}`}
          clientId={clientId}
          setId={setId}
          onActiveChange={setWizardActive}
        />
      ) : null}
    </KpiScreen>
  );
}
